<template>
  <div>
    <div class="home">
      <div class="banner" :style="{backgroundImage:ready?'url('+data.img_pc+')':'#2d2d2d'}">&nbsp;</div>
      <div class="content">
        <transition name="el-fade-in-linear">
          <el-row v-if="ready">
            <el-col :span="4" style="text-align: left;">
              <el-avatar :size="150" :src="data.user_image" @error="errorHandler">
                <img src="image/none.png"/>
              </el-avatar>
            </el-col>
            <el-col :span="8">
              <div class="word_left">
                {{data.w1}}
              </div>
              <div class="word_left">
                {{data.w3}}
              </div>
              <div class="word_left">
                {{data.w5}}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="word_right">
                {{data.w2}}
              </div>
              <div class="word_right">
                {{data.w4}}
              </div>
              <div class="word_right">
                {{data.w7}}
              </div>
            </el-col>
            <el-col :span="4" style="text-align: right">
              <el-image :src="data.qrcode" style="width: 130px;height: 130px;margin: .8rem" fit="fill">
                <div slot="error">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </el-col>
          </el-row>
        </transition>
        <div class="not_ready" v-if="!ready">loading…</div>
      </div>
      <div class="main">
        <el-row v-if="ready">
          <el-col class="box" :span="6" v-for="(item,index) in data.companyList">
            <div style="min-height: 120px;">
              <div class="year">{{item.year}}</div>
              <div class="name">{{item.name}}</div>
              <div class="describe">{{item.describe}}</div>
            </div>
            <div class="line">&nbsp;</div>
            <div class="job ql-editor" v-html="item.job"></div>
          </el-col>
        </el-row>
        <div class="not_ready" v-if="!ready">loading…</div>
      </div>
    </div>
    <div class="bbg">&nbsp;</div>
  </div>
</template>

<script>
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
  import {getUserData} from "../request/service";
  // @ is an alias to /src
  export default {
    name: 'About',
    data(){
      return{
        ready:false,
        active:0,
        data:null,
      }
    },
    methods:{
      errorHandler(){
        return true;
      }
    },
    created() {
      const that=this
      getUserData().then(res=>{
        that.data=res.data
        that.ready=true
      })
    }
  }
</script>

<style scoped>
  .home{
    width: 96%;
    margin: 0 2%;
    position: relative;
    padding-top: 60px;
  }
  .home .banner{
    height: 400px;
    background: #181818;
    background-repeat: no-repeat;
    background-position: center top;
  }
  .home .content{
    width: 1080px;
    margin: -440px auto auto auto;
    height: 200px;
    background: #242424;
    color: #cccccc;
    padding: 3rem 60px 1rem 60px;
    text-align: left;
  }
  .home .main{
    width: 1200px;
    margin:220px auto 2rem auto;
    color: #ffffff;
  }
  .word_left{
    border-style: solid solid none none;
    border-width: 1px ;
    border-color: #666666;
    padding: 1rem;
    text-align: right
  }
  .word_left:last-child{
    border-style: solid solid solid none;
  }
  .word_right{
    border-style: solid none none none;
    border-width: 1px ;
    border-color: #666666;
    padding: 1rem;
    text-align: left;
  }
  .word_right:last-child{
    border-style: solid none solid none;
  }
  .main .box{
    border-width: 1px;
    border-color: #282828 #282828 #1a1a1a #1a1a1a;
    border-style: solid;
    padding: 2rem;
    min-height: 200px;
    text-align: left;
  }
  .main .box:nth-child(4n+0){
    /*border-right: none;*/
  }
  .main .box .year{
    font-size: 1.5rem;
    padding: 0 1rem;
  }
  .main .box .name{
    padding:.5rem 1rem;
  }
  .main .box .describe{
    font-size: .8rem;
    padding:0 1rem;
    color: #cccccc;
  }
  .main .box .line{
    border:1px dashed #666666;
    width: 100%;
    /*background: #666666;*/
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .main .box .job{
    padding:0 1rem;
    margin-bottom: 2rem;
    min-height: 200px;
  }
  .bbg{
    width: 100%;
    max-width: 1920px;
    margin: auto;
    background: url("/image/user_bg.jpg") no-repeat center top;
    background-size: cover;
    height: 353px;
  }
</style>
